import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IUploadIMEIModel } from '../models/model'

export class UploadIMEIApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/netChannelContent/UploadIMEI',
      requesterInfo,
    })
  }

  public async uploadIMEI(req: IUploadIMEIModel[]): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
